import { z } from 'zod';
import { RouteLegTypeEnum } from '@/api/apis/route';
import { REPOSITION_SEGMENT_TYPES } from '@/utils/route';
import {
  withAccommodationValidation,
  withCommonValidation,
  withResourcesValidation,
  withTmdxAviaMaxFlightValidation,
} from './utils';
import {
  BaseAccommodationLegSchema,
  BaseCommercialAviaLegSchema,
  BaseCurriServiceGroundSchema,
  BaseSelfServicedGroundSchema,
  BaseSupplementalLiftAviaSchema,
  BaseTmdxAffiliateGroundSchema,
  BaseTmdxAviaLegSchema,
  BaseTmdxDriveAffiliateGroundSchema,
  BaseTmdxDriveTedsGroundSchema,
  BaseTxCenterGroundSchema,
  BaseTxProviderAviaSchema,
} from './schema';
import { CommonLegResourcesSchemaValues } from './types';

export const LegFormSchema = z
  .discriminatedUnion('legType', [
    BaseTmdxAviaLegSchema,
    BaseSupplementalLiftAviaSchema,
    BaseTxProviderAviaSchema,
    BaseCommercialAviaLegSchema,
    BaseTmdxAffiliateGroundSchema,
    BaseTmdxDriveAffiliateGroundSchema,
    BaseTxCenterGroundSchema,
    BaseCurriServiceGroundSchema,
    BaseTmdxDriveTedsGroundSchema,
    BaseSelfServicedGroundSchema,
    BaseAccommodationLegSchema,
  ])
  .superRefine((data, ctx) => {
    if (data.legType === RouteLegTypeEnum.AccommodationLeg) {
      withAccommodationValidation(data, ctx);
      return;
    }

    withCommonValidation(data, ctx);

    switch (data.legType) {
      case RouteLegTypeEnum.CommercialFlightAviaLeg:
      case RouteLegTypeEnum.TmdxAffiliateGroundLeg:
      case RouteLegTypeEnum.TmdxDriveAffiliateGroundLeg:
      case RouteLegTypeEnum.TxCenterProviderGroundLeg:
      case RouteLegTypeEnum.CurriServiceGroundLeg:
      case RouteLegTypeEnum.TmdxDriveTedsGroundLeg:
      case RouteLegTypeEnum.SelfServicedGroundLeg:
        withResourcesValidation(data, ctx);
        break;
      case RouteLegTypeEnum.SupplementalLiftAviaLeg:
      case RouteLegTypeEnum.TxCenterProviderAviaLeg:
        if (!REPOSITION_SEGMENT_TYPES.includes(data.segmentType)) {
          withResourcesValidation(data as CommonLegResourcesSchemaValues, ctx);
        }
        break;
      case RouteLegTypeEnum.TmdxJetAviaLeg:
        if (!REPOSITION_SEGMENT_TYPES.includes(data.segmentType)) {
          withResourcesValidation(data as CommonLegResourcesSchemaValues, ctx);
        }
        withTmdxAviaMaxFlightValidation(data, ctx);
        break;
      default:
        break;
    }
  });

export type LegFormValues = z.infer<typeof LegFormSchema>;
